import { ECOSYSTEMS_BASE_PATH } from '../constants';

export function getCurrentEcosystemBasePath(currentPath = window.location.pathname): string | undefined {
  // Remove '/portal' prefix if present
  const normalizedPath = currentPath.startsWith('/portal') ? currentPath.replace(/^\/portal/, '') : currentPath;

  for (const [key, path] of Object.entries(ECOSYSTEMS_BASE_PATH)) {
    if (normalizedPath.startsWith(path)) {
      return `/${key}`;
    }
  }

  return '';
}
